import { track } from './analytics.js'

export function trackLastActiveSeparatorChanged(playbookId, actionCard, oldActionCard) {
  if (
    !actionCard.lastActiveSeparator ||
    actionCard.lastActiveSeparator <= 0 ||
    // if user clears some header-section, we make previos active header-section as lastActiveSeparator
    // but it doesn't mean that user has started editing of the section and we shouldn't trrack this change
    // so log scope's only if previos version of AC hasn't contain the separator among enabled
    (oldActionCard?.enabledSeparators?.some(x => x == actionCard.lastActiveSeparator) ?? false)
  ) {
    return
  }

  track('ac_activeScopeChanged', {
    playbookId: playbookId,
    lastActiveSeparator: actionCard.lastActiveSeparator,
  })
}

export function trackRequested(playbookId) {
  const eventData = {
    playbookId: playbookId,
  }
  addUTMParams(eventData)
  track('ac_requested', eventData)
}

export function trackSubmited(playbookId, keywords) {
  const eventData = {
    playbookId: playbookId,
    keywords: keywords,
  }
  addUTMParams(eventData)
  track('ac_submitted', eventData)
}

function addUTMParams(eventData) {
  const params = new URLSearchParams(window.location.search)
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  for (const key of utmKeys) {
    const value = params.get(key)
    if (value) {
      eventData[key] = value
    }
  }
  return eventData
}
